import axios from 'axios';
import { clearAdminToken, getAdminToken } from './adminAuthStorage';

function normalizeApiBaseUrl(url) {
  const fallback = 'http://localhost:3001/api';
  const trimmed = (url || fallback).trim().replace(/\/$/, '');
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

const adminApiClient = axios.create({
  baseURL: normalizeApiBaseUrl(process.env.REACT_APP_API_URL),
  headers: {
    'Content-Type': 'application/json',
  },
});

adminApiClient.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAdminToken();
      window.dispatchEvent(new Event('admin:logout'));
    }
    return Promise.reject(error);
  },
);

export default adminApiClient;
